import { create } from "zustand";
import { INichePreview } from "@/common/api/services/types";

interface INichePreviewState {
  previews: Record<string, INichePreview>;
  updatePreviews: (previews: INichePreview[]) => void;
  getPreview: (nicheId: string) => INichePreview | undefined;
}

export const useNichePreviewStore = create<INichePreviewState>((set, get) => ({
  previews: {},
  updatePreviews: (previews) => set((state) => {
    const next = { ...state.previews };

    previews.forEach((preview) => {
      if (!preview.niche?.id || !preview.gif?.id) {
        return;
      }

      next[preview.niche.id] = preview;
    });

    return { previews: next };
  }),
  getPreview: (nicheId) => get().previews[nicheId],
}));
